// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FormuleSelectorController from "./formule_selector_controller"
application.register("formule-selector", FormuleSelectorController)

import PrestationActesController from "./prestation_actes_controller"
application.register("prestation-actes", PrestationActesController)
